import type { KeyboardEvent } from 'react';

/**
 * Returns true if the keyboard event represents the Space key.
 * Handles multiple browser representations for cross-browser compatibility.
 */
export const isSpaceKeyEvent = <T extends Element = Element>(event: KeyboardEvent<T>): boolean =>
  event.key === ' ' || event.key === 'Spacebar' || event.key === 'Space' || event.code === 'Space';
